import type { FC } from "react";

import ImageLoader from "@Components/ImageLoader";

import { TransitionLink } from "../common/Transition";

import * as css from "./MomentItem.module.css";

export interface IMomentItem {
    id: string;
    index: number;
    linkUrl: string;
    imageUrl: string;
    title?: string;
    additionalInformation: string;
    color?: string;
    selected: boolean;
    isMobile: boolean;
    hideTitleAndButton: boolean;
}

const MomentItem: FC<IMomentItem> = (props) => (
    <TransitionLink
        navigateUrl={props.linkUrl}
        className={`${css.momentItemComponent} ${props.selected ? css.selected : ""}`}
        hideLoading
        telemetryCustom={{
            eventName: "SmarttileClick",
            itemId: props.id,
            origin: "ForYou",
            actionType: "Click",
        }}
    >
        <ImageLoader
            src={props.imageUrl}
            alt={props.title}
            size={props.isMobile ? 600 : 300}
            srcSetAxis="width"
            lazyLoading={(props.isMobile && props.index >= 2) || props.index > 5}
            style={{ borderBottomColor: props.color }}
        />
        {!props.selected && !props.isMobile && !props.hideTitleAndButton && (
            <h3 className={css.imageDescription}>{props.title}</h3>
        )}
        {props.isMobile && (
            <div className={css.content} style={{ backgroundColor: props.color }}>
                <div className={css.description}>
                    <h2 className={css.title}>{props.title}</h2>
                    {props.additionalInformation && (
                        <h5 className={css.additionalInformation}>{props.additionalInformation}</h5>
                    )}
                </div>
            </div>
        )}
    </TransitionLink>
);

export default MomentItem;
